const styles = (theme) => ({
  groupName: {
    paddingLeft: theme.spacing(2),
  },

  drawerContainer: {
    padding: theme.spacing(2),
  },

  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 'space-between',
    padding: theme.spacing(2, 0),
  },

  cancelButton: {
    marginRight: 15,
  },
  container: {
    paddingTop: theme.spacing(5),
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  headerTitle: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
  },
  tabs: {
    backgroundColor: 'white',
  },
  dailyTotals: {
    paddingTop: theme.spacing(2),
  },
  modalContainer: {
    height: 550,
    overflow: 'auto',
  },
  modalHeader: {
    paddingBottom: theme.spacing(2),
    fontSize: 24,
  },
  linkList: {
    alignItems: 'left',
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  listIcon: {
    fill: theme.color.teal,
  },
});

export default styles;
